import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RouteInfo } from 'src/app/layout/sidebar/sidebar.metadata';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private apiUrl="";
  ROUTES: RouteInfo[]=[];
  private currentMenuSubject: BehaviorSubject<any>=new BehaviorSubject(null);
  public currentMenu: Observable<any>=this.currentMenuSubject.asObservable();;

  constructor(private http:HttpClient) {
   }

  public get currentMenuValue() {
    return this.currentMenuSubject.value;
  }

  public setcurrentMenuValue(value) {
    this.currentMenuSubject.next(value);
  }

  public  GetRubriqueEspacesData() : Observable<any>{
    return this.http.get(`/api/Shared/GetRubriqueEspaces`);
  }
   public GetRubriqueEspaces(){
    this.GetRubriqueEspacesData().subscribe(data=>{
      data.forEach(element => {
        let value = this.fillMenu(element);
        if(value.path!==''){
          this.ROUTES.push(value)
        }
      });
    })
    }

  fillMenu(data){
    let routeInfo = {
      path: "",
      title: "",
      iconType: "feather",
      icon: "",
      class: "",
      groupTitle: false,
      badge: "",
      badgeClass: "",
      submenu: [],
    }
    switch (data.Nom) {
      case "ESPACE_AFFICHAGE_DEVOIRS_MAISON":
        routeInfo.title=data.NewDesignation==''?'document':data.NewDesignation;
        routeInfo.path="document";
        routeInfo.icon="trello";
        break;
      case "ESPACE_AFFICHAGE_EMPLOI_TEMPS":
          routeInfo.title=data.NewDesignation==''?'e-temps':data.NewDesignation;
          routeInfo.path="calendar";
          routeInfo.icon="calendar";
        break; 
        case "ESPACE_AFFICHAGE_PRESENCE":
          routeInfo.title=data.NewDesignation==''?'presence':data.NewDesignation;
          routeInfo.path="presence";
          routeInfo.icon="file-text";
        break;  
        case "ESPACE_AFFICHAGE_EVALUATION":
          routeInfo.title=data.NewDesignation==''?'evaluation':data.NewDesignation;
          routeInfo.path="evaluation";
          routeInfo.icon="file-plus";
        break;  
        case "ESPACE_AFFICHAGE_EXAMEN":
          routeInfo.title=data.NewDesignation==''?'examens':data.NewDesignation;
          routeInfo.path="examen";
          routeInfo.icon="file-plus";
        break;
        case "ESPACE_AFFICHAGE_SANCTION":
          routeInfo.title=data.NewDesignation==''?'sanction':data.NewDesignation;
          routeInfo.path="task";
          routeInfo.icon="file-plus";
        break;     
      default:
        break;
    }
    return routeInfo;

  }

}
